export default __webpack_public_path__ + "static/media/marker-gray-yellow.362be0b1.png";